//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionTest(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 17V18H8V17L11 12H13L16 17Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M17 2V4H16V9.97559L21.0049 18V21.9971H3V18L8 9.97559V4L7 4.00098V2H17ZM10 4.00098V10.0283L5 18V19.9951H19V18L14 10.0283V4.00098H10Z" fill="currentColor" /></svg>;
}
export default IconActionTest;